import React, { Component } from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, FormGroup, Label } from 'reactstrap'
import AsyncSelect from 'react-select/async'
import axios from 'axios'
import Swal from 'sweetalert2'

class ManualUserAddModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedUser: null,
      loadingUsers: false,
      userOptions: []
    }
  }

  loadUsers = (inputValue) => {
    return new Promise((resolve) => {
      if (!inputValue || inputValue.trim().length < 2) {
        resolve([])
        return
      }

      const { teamId } = this.props
      if (!teamId) {
        resolve([])
        return
      }

      this.setState({ loadingUsers: true })
      
      axios
        .get(`/users/manuallyAddedForWages/search`, {
          params: {
            teamId: teamId,
            search: inputValue
          }
        })
        .then((res) => {
          this.setState({ loadingUsers: false })
          if (res.data.success) {
            const usersData = res.data.data || []
            const options = usersData.map((user) => ({
              value: user._id,
              label: `${user.first_name} ${user.last_name} (${user.email}) - ${user.is_active ? 'AKTIV' : 'JO-AKTIV'}`,
              isActive: user.is_active
            }))
            resolve(options)
          } else {
            resolve([])
          }
        })
        .catch((err) => {
          console.error('Error loading users:', err)
          this.setState({ loadingUsers: false })
          resolve([])
        })
    })
  }

  handleUserSelect = (selectedOption) => {
    this.setState({ selectedUser: selectedOption })
  }

  handleAddUser = async () => {
    const { selectedUser } = this.state
    const { teamId, month, year, onUserAdded, onClose } = this.props

    if (!selectedUser) {
      Swal.fire('Gabim', 'Ju lutem zgjidhni një përdorues', 'error')
      return
    }

    try {
      Swal.fire({
        title: 'Ju lutem prisni...',
        html: 'Duke shtuar përdoruesin...',
        allowEscapeKey: false,
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading()
        }
      })

      const response = await axios.post('/users/manuallyAddedForWages', {
        userId: selectedUser.value,
        teamId: teamId,
        month: month,
        year: year
      })

      Swal.close()

      if (response.data.success) {
        Swal.fire('Sukses', 'Përdoruesi u shtua me sukses për këtë muaj!', 'success')
        this.setState({ selectedUser: null })
        if (onUserAdded) {
          onUserAdded()
        }
        onClose()
      } else {
        Swal.fire('Gabim', response.data.message || 'Gabim gjatë shtimit të përdoruesit', 'error')
      }
    } catch (error) {
      Swal.close()
      Swal.fire('Gabim', error.response?.data?.message || 'Gabim gjatë shtimit të përdoruesit', 'error')
    }
  }

  render() {
    const { isOpen, onClose } = this.props
    const { selectedUser, loadingUsers } = this.state

    return (
      <Modal isOpen={isOpen} toggle={onClose} size="lg">
        <ModalHeader toggle={onClose}>
          Shto Përdorues Manualisht për Pagat
        </ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label>Kërko dhe zgjedh përdoruesin (Aktiv ose Jo-Aktiv):</Label>
            <AsyncSelect
              value={selectedUser}
              onChange={this.handleUserSelect}
              loadOptions={this.loadUsers}
              isLoading={loadingUsers}
              placeholder="Shkruani emrin ose email-in e përdoruesit..."
              noOptionsMessage={({ inputValue }) => 
                !inputValue || inputValue.length < 2 
                  ? 'Shkruani të paktën 2 shkronja për të kërkuar' 
                  : 'Nuk u gjet asnjë përdorues'
              }
              loadingMessage={() => 'Duke kërkuar...'}
              cacheOptions
              defaultOptions={false}
            />
          </FormGroup>
          <div className="alert alert-info mt-3">
            <strong>Shënim:</strong> Përdoruesi i zgjedhur do të përfshihet për teamin, muajin dhe vitin e zgjedhur, edhe nëse pagat procesohen disa herë.
            Përdoruesi nuk do të përfshihet automatikisht në muajt e tjerë.
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={onClose}>
            Anulo
          </Button>
          <Button color="primary" onClick={this.handleAddUser} disabled={!selectedUser}>
            Shto Përdoruesin
          </Button>
        </ModalFooter>
      </Modal>
    )
  }
}

export default ManualUserAddModal
